<template>
  <v-container class="py-14">
    <!-- Título -->
    <v-row justify="center" class="mb-2">
      <v-col cols="12" md="8" class="text-center">
        <h2 class="display-1 font-weight-bold">
          Selecciona el tipo de consulta
        </h2>
        <p class="subtitle-1 grey--text">
          Elige si deseas validar la seguridad de una persona o de una empresa.
          Nuestros agentes de IA analizarán la información para ofrecerte un reporte confiable y en tiempo real.
        </p>
      </v-col>
    </v-row>

    <!-- Cards de selección -->
    <v-row justify="center" align="center">
      <v-col cols="12" md="4">
        <v-card
          class="pa-6 text-center card-option"
          :class="selectedType === 'persona' ? 'selected' : ''"
          elevation="7"
          @click="selectType('persona')"
        >
          <v-img src="@/assets/icon-persona.svg" contain height="80" class="mb-4 mx-auto" />
          <h3 class="subtitle-1 font-weight-bold">Persona</h3>
          <p class="grey--text">Valida identidad individual, documentos y antecedentes.</p>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card
          class="pa-6 text-center card-option"
          :class="selectedType === 'empresa' ? 'selected' : ''"
          elevation="7"
          @click="selectType('empresa')"
        >
          <v-img src="@/assets/icon-empresa.svg" contain height="80" class="mb-4 mx-auto" />
          <h3 class="subtitle-1 font-weight-bold">Empresa</h3>
          <p class="grey--text">Evalúa riesgos corporativos, cumplimiento y antecedentes.</p>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center" align="center" class="mt-8">
      <v-btn color="primary" rounded class="px-8" :disabled="!selectedType" @click="continuar()">Continuar</v-btn>
    </v-row>
    
  </v-container>
</template>

<script>
export default {
  name: 'ConsultaSelector',
  data() {
    return {
      selectedType: null, // 'persona' o 'empresa'
    };
  },
  methods: {
    selectType(type) {
      this.selectedType = type;
      // Aquí puedes emitir evento o navegar
      console.log('Tipo de consulta seleccionado:', type);
    },
    continuar() {
      if (this.selectedType === 'persona') {
        this.$router.push('/personForm'); // Ruta para formulario de persona
      } else if (this.selectedType === 'empresa') {
        this.$router.push('/enterpriseForm'); // Ruta para formulario de empresa
      }
    },
  },
};
</script>

<style scoped>
.card-option {
  background-color: #f9f9f9;
  border-radius: 16px;
  cursor: pointer;
  transition: all 0.3s ease;
}
.card-option:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}
.selected {
  border: 2px solid #0275b8 !important;
  box-shadow: 0 4px 20px rgba(0, 86, 255, 0.15);
}
</style>
